import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { HeatmapActivityOption } from '../types/HeatmapActivity';
import { HeatmapTimeRangeOption } from '../types/HeatmapTimeRange';
import { HeatmapOption, HeatmapOptionKey } from '../types/HeatmapOptionsData';

export type HeatmapsState = {
  availableOptions?: HeatmapOption[];
  currentlySelectedOptions?: Partial<Record<HeatmapOptionKey, HeatmapActivityOption | HeatmapTimeRangeOption>>;
  urlTemplate?: string;
  isHeatmapFilterModalOpen: boolean;
};

export const initialHeatmapsState: HeatmapsState = {
  isHeatmapFilterModalOpen: false
};

export const heatmapsSlice = createSlice({
  name: 'heatmaps',
  initialState: initialHeatmapsState,
  reducers: {
    updateAvailableOptions: (state, action: PayloadAction<HeatmapOption[]>) => {
      state.availableOptions = action.payload;
    },
    updateCurrentlySelectedOptions: (state, action: PayloadAction<Record<HeatmapOptionKey, HeatmapActivityOption | HeatmapTimeRangeOption>>) => {
      state.currentlySelectedOptions = { ...state.currentlySelectedOptions, ...action.payload };
    },
    updateUrlTemplate: (state, action: PayloadAction<string>) => {
      state.urlTemplate = action.payload;
    },
    updateIsHeatmapFilterModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isHeatmapFilterModalOpen = action.payload;
    }
  }
});

export const { updateAvailableOptions, updateCurrentlySelectedOptions, updateUrlTemplate, updateIsHeatmapFilterModalOpen } = heatmapsSlice.actions;

export const heatmapsReducer = heatmapsSlice.reducer;
